import React from 'react'
import BlogPost, { BlogPostType } from '../../components/BlogPost'
import post from '../../data/blog/preco-sa-nam-sniva'
import { language } from '../../global'

const PrecoSaNamSniva: React.FC = () => {
  return <BlogPost post={post[language as keyof typeof post] as BlogPostType} />
}

export default PrecoSaNamSniva
